import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useScrollToElement = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const scrollToElement = useCallback((elementId: string) => {
        const element = document.getElementById(elementId);

        // If we're not on the homepage and the element exists, navigate to homepage first
        if (location.pathname !== '/' && element) {
            navigate('/', { state: { scrollTo: elementId } });
            return;
        }

        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [location.pathname, navigate]);

    return scrollToElement;
};